module.exports = __webpack_public_path__ + "img/Mahjong_logo.1.eafef0d3.png";